(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        var _this = this;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.score = 0;
        this.status = "idle";
        this._initialState = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : Array.from({
            length: this.size
        }, function() {
            return Array(_this.size).fill(0);
        });
        this.state = this._initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return;
                var oldState = JSON.stringify(this.state);
                var gainedPoints = 0;
                for(var r = 0; r < this.size; r++){
                    var _this__slideAndMergeRow = this._slideAndMergeRow(this.state[r]), newMergedRow = _this__slideAndMergeRow.newMergedRow, points = _this__slideAndMergeRow.points;
                    this.state[r] = newMergedRow;
                    gainedPoints += points;
                }
                if (JSON.stringify(this.state) !== oldState) {
                    this.score += gainedPoints;
                    this._addRandomTile();
                }
                this._checkStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing") return;
                var oldState = JSON.stringify(this.state);
                var gainedPoints = 0;
                for(var r = 0; r < this.size; r++){
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[r]).reverse();
                    var _this__slideAndMergeRow = this._slideAndMergeRow(reversedRow), newMergedRow = _this__slideAndMergeRow.newMergedRow, points = _this__slideAndMergeRow.points;
                    this.state[r] = newMergedRow.reverse();
                    gainedPoints += points;
                }
                if (JSON.stringify(this.state) !== oldState) {
                    this.score += gainedPoints;
                    this._addRandomTile();
                }
                this._checkStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(c) {
                    var column = _this.state.map(function(row) {
                        return row[c];
                    });
                    var _this__slideAndMergeRow = _this._slideAndMergeRow(column), newMergedRow = _this__slideAndMergeRow.newMergedRow, points = _this__slideAndMergeRow.points;
                    for(var r = 0; r < _this.size; r++)_this.state[r][c] = newMergedRow[r];
                    gainedPoints += points;
                };
                if (this.status !== "playing") return;
                var oldState = JSON.stringify(this.state);
                var gainedPoints = 0;
                for(var c = 0; c < this.size; c++)_loop(c);
                if (JSON.stringify(this.state) !== oldState) {
                    this.score += gainedPoints;
                    this._addRandomTile();
                }
                this._checkStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(c) {
                    var column = _this.state.map(function(row) {
                        return row[c];
                    }).reverse();
                    var _this__slideAndMergeRow = _this._slideAndMergeRow(column), newMergedRow = _this__slideAndMergeRow.newMergedRow, points = _this__slideAndMergeRow.points;
                    var mergedReversed = newMergedRow.reverse();
                    for(var r = 0; r < _this.size; r++)_this.state[r][c] = mergedReversed[r];
                    gainedPoints += points;
                };
                if (this.status !== "playing") return;
                var oldState = JSON.stringify(this.state);
                var gainedPoints = 0;
                for(var c = 0; c < this.size; c++)_loop(c);
                if (JSON.stringify(this.state) !== oldState) {
                    this.score += gainedPoints;
                    this._addRandomTile();
                }
                this._checkStatus();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "_addRandomTile",
            value: function _addRandomTile() {
                var emptyCells = [];
                for(var r = 0; r < this.size; r++){
                    for(var c = 0; c < this.size; c++)if (this.state[r][c] === 0) emptyCells.push([
                        r,
                        c
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                this.state[row][col] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "_slideAndMergeRow",
            value: function _slideAndMergeRow(row) {
                var numbers = row.filter(function(num) {
                    return num !== 0;
                });
                var mergedRow = [];
                var points = 0;
                for(var i = 0; i < numbers.length; i++)if (numbers[i] === numbers[i + 1]) {
                    var mergedValue = numbers[i] * 2;
                    mergedRow.push(mergedValue);
                    points += mergedValue;
                    i++;
                } else mergedRow.push(numbers[i]);
                while(mergedRow.length < this.size)mergedRow.push(0);
                return {
                    newMergedRow: mergedRow,
                    points: points
                };
            }
        },
        {
            key: "_checkStatus",
            value: function _checkStatus() {
                for(var r = 0; r < this.size; r++){
                    for(var c = 0; c < this.size; c++)if (this.state[r][c] === 2048) {
                        this.status = "win";
                        return;
                    }
                }
                for(var r1 = 0; r1 < this.size; r1++){
                    for(var c1 = 0; c1 < this.size; c1++)if (this.state[r1][c1] === 0) {
                        this.status = "playing";
                        return;
                    }
                }
                for(var r2 = 0; r2 < this.size; r2++)for(var c2 = 0; c2 < this.size - 1; c2++){
                    var current = this.state[r2][c2];
                    if (current === this.state[r2][c2 + 1] && c2 < this.size - 1) {
                        this.status = "playing";
                        return;
                    }
                    if (r2 < this.size - 1 && current === this.state[r2 + 1][c2]) {
                        this.status = "playing";
                        return;
                    }
                }
                this.status = "lose";
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                this.score = 0;
                this.status = "playing";
                if (!this.state || this.state.every(function(row) {
                    return row.every(function(cell) {
                        return cell === 0;
                    });
                })) this.state = Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
                this._addRandomTile();
                this._addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                this.state = this._initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
var $197cd56b15c33885$var$startBtn = document.querySelector(".button");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$renderBoard() {
    var state = $197cd56b15c33885$var$game.getState();
    state.flat().forEach(function(value, index) {
        var cell = $197cd56b15c33885$var$cells[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value) cell.classList.add("field-cell--".concat(value));
    });
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
}
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$updateMessages();
});
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.remove("start");
        $197cd56b15c33885$var$startBtn.classList.add("restart");
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startBtn.textContent = "Start";
        $197cd56b15c33885$var$startBtn.classList.remove("restart");
        $197cd56b15c33885$var$startBtn.classList.add("start");
    }
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$updateMessages();
});
function $197cd56b15c33885$var$updateMessages() {
    var statusOfGame = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    if (statusOfGame === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (statusOfGame === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    else if (statusOfGame === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
}

})();
//# sourceMappingURL=index.2778bce4.js.map
